module.exports = __webpack_public_path__ + "img/inlay&onlay.7efae55b.png";